import { useContext, useState } from "react";
import toast from "react-hot-toast";

import { LabourerContext } from "../contexts/LabourerContext";
import { Helmet } from "react-helmet";
import DataTable from "react-data-table-component";
import TableLoader from "./TableLoader";
import SectionHeader from "./SectionHeader";
import Modal from "./Modal";
import RequestLeaveForm from "./RequestLeaveForm";

import leaveRequestService from "../services/leaveRequestService";
import useLeaveRequests from "../hooks/useLeaveRequests";
import { formatDateToSydneyTimeZone } from "../utils/dateUtils";

const LabourerLeaveRequests = () => {
  const { labourer } = useContext(LabourerContext);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const { data, isLoading, mutate } = useLeaveRequests({ labourerId: labourer._id, page, perPage });

  const leaveRequests = data?.leaveRequests;
  const leaveRequestCount = data?.count;

  const [isRequestLeaveModalOpen, setIsRequestLeaveModalOpen] = useState(false);

  const handlePageChange = page => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
  };

  const columns = [
    {
      name: "Status",
      selector: (row) => row.status
    },
    {
      name: "Reason",
      selector: (row) => row.reason
    },
    {
      name: "Start Date",
      selector: (row) => row.startDate,
      format: (row) => formatDateToSydneyTimeZone(row.startDate)
    },
    {
      name: "End Date",
      selector: (row) => row.endDate,
      format: (row) => formatDateToSydneyTimeZone(row.endDate)
    }
  ];

  const handleLeaveRequestSubmit = async (payload) => {
    try {
      await leaveRequestService.createLeaveRequest({
        labourer: labourer._id,
        ...payload
      });

      mutate();

      setIsRequestLeaveModalOpen(false);
      toast.success('Leave request submitted', { icon: '🎉' });
    } catch (error) {
      console.error(error);
      toast.error('Failed to submit leave request. Please try again', { icon: '❌' });
    }
  }

  return (
    <div className='border border-ase-blue rounded-lg pb-1'>
      <Helmet>
        <title>Leave requests | ASE Group</title>
      </Helmet>

      <SectionHeader title='Leave requests' actionsLeft={
        <button
          onClick={e => setIsRequestLeaveModalOpen(true)}
          className='px-2 py-1 bg-white rounded-md text-ase-blue font-semibold text-xs'
        >
          Add
        </button>
      } />

      <DataTable
        columns={columns}
        data={leaveRequests}
        highlightOnHover
        striped
        pointerOnHover
        pagination
        paginationServer
        progressPending={isLoading}
        progressComponent={<TableLoader />}
        paginationTotalRows={leaveRequestCount}
        paginationRowsPerPageOptions={[10, 20, 50]}
        paginationPerPage={perPage}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
      />

      <Modal isOpen={isRequestLeaveModalOpen}>
        <RequestLeaveForm
          onSubmit={handleLeaveRequestSubmit}
          onCloseClicked={e => setIsRequestLeaveModalOpen(false)}
        />
      </Modal>
    </div>

  );
}

export default LabourerLeaveRequests;
